import { PageDefinition } from "@cervval.js/client-html5-spa/navigation";
import { injector } from "@cervval.js/common/src/dependencies/injector";
import { ObjectTools } from "@cervval.js/common/tools";
import { CONNECTED_PS } from "@ehealth_tools/common-booking/src/permissions/permissionString";
import { BOOKING_SERVICE } from "@ehealth_tools/common-booking/src/services/abstractCommonBooking.service";
import { BookingPages } from "../../../page.i18n";
import { AbstractClientBookingService } from "../../../services/abstractClientBooking.service";

export const profilePages = {
    "profile": ObjectTools.is<PageDefinition>({
        importPromise: () => { return import("./profilePage").then((module) => new module.Profile()); },
        menuItem: {
            label: BookingPages().myProfile,
            iconClasses: "fa-regular fa-user fa-xl"
        },
        permissions: [CONNECTED_PS]
    }),
    "relation": ObjectTools.is<PageDefinition>({
        importPromise: () => { return import("./relationPage/relationPage").then((module) => new module.RelationPage()); },
        permissions: [CONNECTED_PS]
    }),
    "professional": ObjectTools.is<PageDefinition>({
        importPromise: () => {
            return import("./professionalPage/professionalPage").then((module) => new module.Professional({
                googleApiToken: injector.get<AbstractClientBookingService>(BOOKING_SERVICE).googleMapToken,
                googleMapUid: injector.get<AbstractClientBookingService>(BOOKING_SERVICE).googleMapUid
            }));
        },
        permissions: [CONNECTED_PS]
    }),
    "calendar": ObjectTools.is<PageDefinition>({
        importPromise: () => { return import("./calendarPage/calendarPage").then((module) => new module.CalendarPage()); },
        permissions: [CONNECTED_PS]
    })
};